import React from "react";
import {EmojiPeopleOutlined} from "@material-ui/icons";
import {Typography, useTheme} from "@material-ui/core";
import useStyle from "./styles"

export default function SignedOut(){
    const classes = useStyle(useTheme())
    return (
        <div className={classes.root}>
            <EmojiPeopleOutlined />
            <Typography>
                You have successfully signed out
            </Typography>
        </div>
    )
}